<template>
  <div style="position: relative; text-align: center">
    <img
      class="banner-img"
      src="@/assets/apple-tv.png"
      alt="img"
    />
    <VueVideoSection
      :elementId="'header-background-video'"
      :ref="'header-background-video'"
      :mp4Source="$props.videoName"
      :playsinline="true"
      :loop="true"
      :autoplay="true"
      :autobuffer="true"
      :muted="true"
    >
    </VueVideoSection>
  </div>
</template>

<script>
export default {
  name: "AppleTvVideo",
  props: {
    videoName: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";
.banner-img {
  width: 60vw;
  max-width: 830px;
}
.vue-video-section-wrapper {
  position: absolute !important;
  top: 0.5% !important;
  left: -3% !important;
  height: 84% !important;
}
@media only screen and (max-width: $screen-lg) {
  .vue-video-section-wrapper {
    left: -1.9% !important;
  }
}
@media only screen and (max-width: 1450px) {
  .vue-video-section-wrapper {
    left: -2.5% !important;
  }
}
@media only screen and (max-width: $screen-xs) {
  .vue-video-section-wrapper {
    left: -2.8% !important;
    height: 83.6% !important;
    top: 0.7% !important;
  }
  .banner-img {
    width: 90vw;
  }
}
</style>
